// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"451":"d72bad9b","2538":"d72bad9b","8882":"035277ca","8930":"d72bad9b"}[chunkId] + ".chunk.css";
};